<template>
    <div id="myCollection">
        <div class="myCollection-content">
            <div id="Top" class="swiper-container swiperTop">
				<swiper :options="swiperTop" class="swiper-wrapper" ref="Top">
					<swiper-slide class="swiper-slide selected">文章收藏</swiper-slide>
                    <swiper-slide class="swiper-slide">問答收藏</swiper-slide>
                    <swiper-slide class="swiper-slide">法規收藏</swiper-slide>
				</swiper>
			</div>
            <div id="Pages" class="swiper-container swiperPages">
                <swiper :options="swiperPages" class="swiper-wrapper" ref="Pages">
                    <swiper-slide class="swiper-slide Article">
                        <div class="detailWrap">
                            <div class="articleList">
                                <ul>
                                    <li v-for="(news,news_ind) in article_list" :key="news_ind">
                                        <router-link :to="{name:'newsDetail', params: { id : news.news_id}}">
                                            <div class="topicImg">
                                                <div class="mainImg" :style="'background-image:url('+news.title_img+')'" v-if="news.title_img != ''"></div>
                                                <div class="mainImg" v-if="news.title_img == ''"></div>
                                            </div>
                                            <div class="txt-info">
                                                <span class="article_desc">{{news.title}}</span>
                                                <span class="article_date">{{news.newsDate.split(" ")[0]}}</span>
                                                <div class="metaDiv">
                                                    <span class="cgy-tag">{{news.type_name}}</span>
                                                    <span class="bookmark-tag" v-on:click.prevent="SetFavorites(news.news_id,true,0)"><i class="_icon-bookmark icon-bookmark-full bookmarkIcon active"></i></span>
                                                </div>
                                            </div>
                                        </router-link>
									</li>
                                </ul>
                            </div>
                        </div>
                        <div class="emptyWrap" v-if="article_list.length == 0"><!--css已設display:none-->
                            您目前沒有任何收藏喔!
                        </div>                      
                    </swiper-slide>
                    <swiper-slide class="swiper-slide FQA">
                        <div class="detailWrap">
                            <div class="articleList FQAList">
                                <ul>
                                    <li v-for="(FAQ,FAQ_ind) in FAQ_List" :key="FAQ_ind">
										<router-link :to="{name:'FAQDetail', params: { id : FAQ.qa_id}}">
											<div class="txt-info">
												<h4 class="article_desc">{{FAQ.qa_title}}</h4>
												<span class="bookmark-tag" v-on:click.prevent="SetFavorites(FAQ.qa_id,true,1)"><i class="_icon-bookmark icon-bookmark-full bookmarkIcon active"></i></span>
											</div>
										</router-link>
									</li>	
                                </ul>
                            </div>
                        </div>
                        <div class="emptyWrap" v-if="FAQ_List.length == 0">
                            您目前沒有任何收藏喔!
                        </div>                       
                    </swiper-slide>
                    <swiper-slide class="swiper-slide LegalRule">
                        <div class="detailWrap">
                            <div class="articleList legalList">
                                <ul>
                                    <li v-for="(legal,legal_ind) in legal_List" :key="legal_ind">
										<router-link :to="{name:'legalRuleDetail', params: { id : legal.rule_id}}">
											<div class="txt-info">
                                                <h3>{{legal.rule_chapter}}</h3>
                                                <h3>{{legal.rule_name}}</h3>
                                                <p v-html="legal.content" style="margin-top:10px"></p>
												<span class="bookmark-tag" v-on:click.prevent="SetFavorites(legal.rule_id,true,2)"><i class="_icon-bookmark icon-bookmark-full bookmarkIcon active"></i></span>
											</div>
										</router-link>
									</li>	
                                </ul>
                            </div>
                        </div>
                        <div class="emptyWrap" v-if="legal_List.length == 0">
                            您目前沒有任何收藏喔!
                        </div> 
                    </swiper-slide>
                </swiper>
            </div>
			<!-- 加入收藏／取消收藏 -->
			<!-- <div class="sqToast">
				<div class="sq-wrapper">
					<div class="content">
						<i class="icon-bookmark"></i>
						<div class="txt">已取消 收藏</div>
					</div>
				</div>
			</div> -->
			<!-- /加入收藏／取消收藏 -->			
			
			<favoritesToast
                :show="toastControl.show"
                :full="toastControl.full"
                :content="toastControl.content"
                :showTime="toastControl.showTime"
                @close="toastControl.show = false"
            ></favoritesToast>
        </div>
    </div>
</template>

<script>
import favoritesToast from '@/components/common/toast/favoritesToast';
    export default {
        name: 'myCollection',
        components: { favoritesToast },
        data () {
            return {
                swiperTop: {
                    slidesPerView: 3,
                    aginationClickable: true,//此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
                    loop: false,//是否可循环
                    resistanceRatio:0,
                    initialSlide:this.$route.params.page,
                    on:{
                        click:function(){
                            console.log(this.clickedIndex)
                        }
                    }
                },
                swiperPages:{
                    direction: 'horizontal',//Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
                    loop: false,
                    autoHeight: true,//自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
                    initialSlide:this.$route.params.page,
                    on:{
                        slideChangeTransitionStart(){
                            $(".swiperTop .swiper-slide").removeClass("selected");
                            $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
                        },
                        slideChangeTransitionEnd(){
                            $(".swiperTop .swiper-slide").removeClass("selected");
                            $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
                        }
                    }
                },
                url : Imgurl,
                article_list:new Array(),
                FAQ_List:new Array(),
                legal_List:new Array(),
                toastControl:{
                    show: false,
                    full: false,
                    content: '',
                    showTime: 1000
                }
            }
        },
        mounted(){
            let vobj = this;
            //swiper設定
            let targetPage =  this.$route.query.page;
            this.$nextTick(() => {
                const Top = this.$refs.Top.swiper
                const Pages = this.$refs.Pages.swiper
                Pages.controller.control = Top

                let setCurrentSlide = (ele, index)=>{
                    $(".swiperTop .swiper-slide").removeClass("selected");
                    ele.addClass("selected");
                }  
                Top.slides.each(function(index, val){
                    var ele = $(this);
                    ele.on("click", function() {
                        setCurrentSlide(ele, index);
                        Pages.slideTo(index, 500);
                    });
                })
                $('#Pages').find(".swiper-slide").map(function(){
                    let PageHeight = $(window).height()-$('#Top').height();
                    $(this).css('height',PageHeight+'px');
                    
                    console.log($(window).height())
                    console.log($('#Top').height())
                });
            })
            vobj.GetCollectionArticleList()
            vobj.GetCollectionFAQList()
            vobj.GetCollectionLegalRule()
        },
        methods:{
            //回傳標籤名稱
            chn_tag(news_type){
                return this.$root.GetNewsTypeChn(news_type);
            },
            //取的收藏資訊
            GetCollectionArticleList(){
                let vobj=this;
                this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetKeepCommitteeNews`,{
                    headers:{Authorization: Token}
                }).then((response) => {
                    if(response.status == 200){
                        vobj.article_list =  response.data.data
                        console.log(vobj.article_list)
                    }
                })
            },
            //取得收藏問答
            GetCollectionFAQList(){
                let vobj=this;
                this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetKeepCommitteeQA`,{
                    headers:{Authorization: Token}
                }).then((response) => {
                    if(response.status == 200){
                        vobj.FAQ_List =  response.data.data
                        console.log(vobj.FAQ_List);
                    }
                })
            },
            //取得收藏法規
            GetCollectionLegalRule(){
                let vobj=this;
                this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetKeepCommitteeLegalRule`,{
                    headers:{Authorization: Token}
                }).then((response) => {
                    if(response.status == 200){
                        vobj.legal_List =  response.data.data
                        console.log(vobj.legal_List);
                    }
                })
            },
            //收藏設定
            SetFavorites(id,status,type){
                let vobj = this;
                let status_val = 0;
                status ? (status_val=0 ) : (status_val=1);
                vobj.$root.SetFavorites(type,id,status_val,function(res){
                    if(res){
                        console.log(res)
                        switch (type) {
                            case 0:
                                let del_ind = 0;
                                vobj.article_list.map(function(val,ind){
                                    if(val.news_id==id){vobj.article_list.splice(ind,1);}
                                    vobj.ShowsqToastDiv();
                                });
                                break;
                            case 1:
                                vobj.FAQ_List.map(function(val,ind){
                                    if(val.qa_id==id){vobj.FAQ_List.splice(ind,1);}
                                    vobj.ShowsqToastDiv();     
                                });                        
                                break;
                            case 2:
                                vobj.legal_List.map(function(val,ind){
                                    if(val.rule_id==id){vobj.legal_List.splice(ind,1);}
                                    vobj.ShowsqToastDiv();
                                });                                 
                                break;                                                        
                        }
                    }
                });
            },
            //取消收藏提示
            ShowsqToastDiv(){
                this.toastControl.content = '已取消收藏'
                this.toastControl.show = true
                // $(".sqToast").show();
                // setTimeout(()=>{
                //     $(".sqToast").hide();
                // },1000)
            }            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myCollection.vue